// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".overridesTabs___zUFJ6{margin-top:16px}\n", "",{"version":3,"sources":["webpack://./src/routes/Overrides/Overrides.css"],"names":[],"mappings":"AAAA,uBACI,eAAA","sourcesContent":[".overridesTabs {\n    margin-top: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overridesTabs": "overridesTabs___zUFJ6"
};
export default ___CSS_LOADER_EXPORT___;
